export default __webpack_public_path__ + "static/logo-cancer-care-8c3a991e67cdc38d1de76cc34b20a0c9.png";